import React from 'react';

import MultiCheckboxWithIcon from '@r1-frontend/ui-react/components/controls/multiCheckboxWithIcon';
import Toggle from '@r1-frontend/ui-react/components/controls/Toggle';

import * as ST from './styled';

export interface ICheckboxItem {
    id: string,
    checked: boolean,
    disabled?: boolean,
    label: string,
}

export interface IFiltersProps {
    checkboxItems: ICheckboxItem[],
    switcherValues: { leftText: string, rightText: string },
    onClickCheckbox: (id: string) => void,
    onClickSwitcher: (id: string) => void,
    activeSwitcherTab: string,
}

/**
 * Выводит свитчер и список чекбоксов
 */
export const CheckboxList = ({
    checkboxItems,
    switcherValues,
    onClickSwitcher,
    onClickCheckbox,
    activeSwitcherTab,
    ...rest
}: IFiltersProps) => {
    return (
        <ST.CheckboxList {...rest}>
            <ST.SwitcherWrap>
                <Toggle
                    textsValues={switcherValues}
                    onChangeCallback={onClickSwitcher}
                    activeTab={activeSwitcherTab}
                />
            </ST.SwitcherWrap>

            {checkboxItems.map(item => {
                return (
                    <MultiCheckboxWithIcon
                        key={item.id}
                        label={item.label}
                        value={item.id}
                        isChecked={item.checked}
                        onClick={onClickCheckbox}
                        disabled={item.disabled}
                        data-test={'checkbox'}
                    />
                );
            })}
        </ST.CheckboxList>
    );
};
